import { Language } from '../Language/Language.types';
import { Period, UnitCode } from '../invoice/Invoice.types';
import { Task } from '../order/Order.types';
import { SchambeckUser } from '../user/User.types';

/**
 * DeliveryNotes to create a pdfDocument
 */
export interface DeliveryNote {
  id: string;
  createdBy: string;
  createDate: Date;
  updatedBy?: string;
  lastUpdated?: Date;
  orderId?: string;
  annotation: string;
  language: Language;
  deliveredPositions: DeliveryPosition[];
  deliveryDate: Date;
  performancePeriod: Period;
  numberRangeNumber: string;
  projectId?: string;
  deliveryAddress?: CustomAddress;
  invoiceId?: string;
  delivered?: boolean;
  customConfig?: CustomConfig;
  areaId?: string;
  mailRecipientId?: string;
  customerOrderNumber?: string;
}

/**
 * Holds customer and office informations for manually created deliveryNotes
 */
export interface CustomConfig {
  customerId: string;
  customerLocationId: string;
  customerContactId: string;
  officeId: string;
}

/**
 * Neccessary config to create a document for the deliveryNote
 */
export interface DeliveryNoteConfig {
  deliveryNote: DeliveryNote;
  user: SchambeckUser;
  language: Language;
}

/**
 * Single position for a deliveryNote
 */
export interface DeliveryPosition {
  id: string;
  position: number;
  task: Task;
  amount?: number;
  unitCode: UnitCode;
  batchNumber: string;
  comment: string;
  condition: DeliveryNoteCondition;
  deliveryType?: DeliveryType;
}
/**
 * Used to indicate the type of a delivery for a deliveryNote
 */
export enum DeliveryType {
  PARTIAL = 'PARTIAL',
  FULL = 'FULL',
  NONE = 'NONE',
}

/**
 * DeliveryNoteCondition fo delivered positions on a deliveryNote
 */
export enum DeliveryNoteCondition {
  IO = 'IO',
  NIO = 'NIO',
  OTHER = 'OTHER',
}

/**
 * Holds the adress information necccessary to create the address header on a
 * letter
 */
export interface CustomAddress {
  name: string;
  name2?: string;
  street: string;
  streetNumber: string;
  zip: string;
  city: string;
  countryCode?: string;
}
